import type { TimeoutClientCause } from '../error';

/** Counts transitions to a hidden page: a request that spans one was in flight across a freeze. */
let hiddenTransitions = 0;

const isHidden = (): boolean => typeof document !== 'undefined' && document.visibilityState === 'hidden';

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (isHidden()) {
      hiddenTransitions += 1;
    }
  });
}

/** Probed when the timeout fires, not when it is handled: by then the tab is visible again. */
export function watchClientCause(): () => TimeoutClientCause | undefined {
  const hiddenAtStart = hiddenTransitions;
  const startedHidden = isHidden();

  return () => {
    // `navigator.onLine === false` is the only trustworthy half: `true` merely means a link exists.
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return 'offline';
    }
    return startedHidden || hiddenTransitions !== hiddenAtStart ? 'backgrounded' : undefined;
  };
}
